import { format, millisecondsToSeconds } from 'date-fns';
import { SupportedLanguages } from '../locale/i18n.types';
import localeMapper from './constants/dateLocaleMapper';

interface TimeFormat {
  timestamp: string | Date;
  timeFormat?: string;
  lng?: SupportedLanguages;
}

export const timeFormat = ({
  timestamp,
  timeFormat: requiredFormat = 'dd-MMM-yyyy HH:mm:ss',
  lng = 'en'
}: TimeFormat): string => {
  if (!timestamp) {
    return '';
  }

  try {
    return format(new Date(timestamp), requiredFormat, {
      locale: localeMapper[lng]
    });
  } catch (err) {
    return '';
  }
};

export const addDays = (timestamp: string | Date, days: number): Date => {
  const date = new Date(timestamp);
  date.setDate(date.getDate() + days);

  return date;
};

export const getMonthName = (month: number) => format(new Date(2014, month - 1, 11), 'MMMM');

const millisecondsToSecondsWithBuffer = (milliseconds: number) => {
  let seconds = 0;
  let msec = milliseconds;

  if (milliseconds >= 1000) {
    seconds = millisecondsToSeconds(milliseconds);
    msec = milliseconds % 1000;
  }

  return { seconds, msec };
};

export const millisecondsToSecondsWithBufferStr = (milliseconds: number) => {
  const { seconds, msec } = millisecondsToSecondsWithBuffer(milliseconds);
  let str = '';

  if (seconds) {
    str = `${seconds}s `;
  }

  if (msec) {
    str += `${msec} msec`;
  }

  if (!str) {
    return '0 msec';
  }

  return str;
};

export const microToMilliSeconds = (microseconds: number) => {
  return microseconds ? microseconds / 1000 : microseconds;
};
